import { render, staticRenderFns } from "./Asam.vue?vue&type=template&id=25ef35ef&"
import script from "./Asam.vue?vue&type=script&lang=js&"
export * from "./Asam.vue?vue&type=script&lang=js&"
import style0 from "./Asam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports